import React from 'react';
import { Icon } from '../../components/ui';

/*
 * SetupNavHead — the top row of a setup pane's left column.
 *
 * A left-facing back caret + the pane title, BOTH of which collapse the setup
 * pane back to the Event Monitor (so there are several ways out: this caret, the
 * title, the "Done" button in the foot, or re-clicking the item in the left nav).
 * Any pane actions (e.g. the "+ Add" button) are passed as children and sit at
 * the right. `onBack` mirrors each pane's own "Done" handler — dirty-guarded in
 * the panes that guard their draft (Organization, Users & Guards).
 */
export default function SetupNavHead({ title, onBack, children }) {
  return (
    <div className="setup__navhead">
      {onBack && (
        <button
          type="button"
          className="setup__back"
          onClick={onBack}
          title="Back to Event Monitor"
          aria-label="Back to Event Monitor"
        >
          <Icon name="chevronLeft" size={16} />
        </button>
      )}
      {onBack ? (
        <button
          type="button"
          className="setup__navtitle grow"
          onClick={onBack}
          title="Back to Event Monitor"
        >
          <span className="eyebrow">{title}</span>
        </button>
      ) : (
        <div className="grow"><span className="eyebrow">{title}</span></div>
      )}
      {children}
    </div>
  );
}
